import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UploadedFileDetail } from '../../../shared/components';

@Injectable({
    providedIn: 'root',
})
export class CommissionsService {
    private basePath = `${environment.apiUrl}/commissions`;
    constructor(private http: HttpClient) {}

    public sendFile(file: File, fileDetail: UploadedFileDetail) {
        const formData = new FormData();
        formData.append('file', file);

        for (const key in fileDetail) {
            formData.append(key, fileDetail[key as keyof UploadedFileDetail]);
        }

        return this.http.post(this.basePath, formData);
    }
}
